import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { BottomNavbarComponent } from '../components/bottom-navbar/bottom-navbar.component';
import { AlertBoxComponent } from '../components/custom/alert-box/alert-box.component';
import { DropDownComponent } from '../components/custom/drop-down/drop-down.component';
import { CustomInputComponent } from '../components/custom/input/input.component';
import { LoanCardComponent } from '../components/custom/loan-card/loan-card.component';
import { TopNavbarComponent } from '../components/top-navbar/top-navbar.component';
import { InfiniteScrollDirective } from '../directives/infinite-scroll.directive';
import { IndianFormatPipe } from '../pipe/indian-format.pipe';
import { MemberModalComponent } from '../components/custom/member-modal/member-modal.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { ConfiramtionModalComponent } from '../components/custom/confirmation-modal/confirmation-modal.component';
import { DateFilterModalComponent } from '../components/custom/date-filter-modal/date-filter-modal.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CalendarModule } from 'primeng/calendar';
// import { DatePickerModule } from 'primeng/datepicker';
import { DatePickerComponent } from '../components/custom/date-picker/date-picker.component';
import { RadioGroupComponent } from '../components/custom/radio-group/radio-group.component';
import { TableComponent } from '../components/custom/table/table.component';
import { NormalizeStringPipe } from '../pipe/normalist-string.pipe';
import { AssetCardComponent } from '../components/custom/asset-card/asset-card.component';
import { TrainingSkillCardComponent } from '../components/custom/training-skill-card/training-skill-card.component';

@NgModule({
    declarations: [
        BottomNavbarComponent,
        CustomInputComponent,
        DropDownComponent,
        DatePickerComponent,
        IndianFormatPipe,
        InfiniteScrollDirective,
        TopNavbarComponent,
        AlertBoxComponent,
        LoanCardComponent,
        MemberModalComponent,
        ConfiramtionModalComponent,
        DateFilterModalComponent,
        RadioGroupComponent,
        TableComponent,
        AssetCardComponent,
        TrainingSkillCardComponent
    ],
    imports: [
        CommonModule,
        DialogModule,
        DropdownModule,
        // DatePickerModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatRadioModule,
        MatSelectModule,
        MatStepperModule,
        MatToolbarModule,
        MatSlideToggleModule,
        NormalizeStringPipe,
        ReactiveFormsModule,
        ToastModule,
        TranslateModule,
        MatAutocompleteModule,
        MatDialogModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        CalendarModule
    ],
    exports: [
        BottomNavbarComponent,
        CommonModule,
        CustomInputComponent,
        DialogModule,
        DropDownComponent,
        DatePickerComponent,
        DropdownModule,
        IndianFormatPipe,
        InfiniteScrollDirective,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatRadioModule,
        MatSelectModule,
        MatStepperModule,
        MatToolbarModule,
        MatSlideToggleModule,
        NormalizeStringPipe,
        ReactiveFormsModule,
        ToastModule,
        TopNavbarComponent,
        TranslateModule,
        AlertBoxComponent,
        LoanCardComponent,
        MatAutocompleteModule,
        MatDialogModule,
        MatTableModule,
        ConfiramtionModalComponent,
        DateFilterModalComponent,
        MatDatepickerModule,
        MatNativeDateModule,
        CalendarModule,
        RadioGroupComponent,
        TableComponent,
        AssetCardComponent,
        TrainingSkillCardComponent
    ]
})
export class SharedModule { }
